import { font } from "./fragments";

export const monogramProduct = `
query getProduct($id: ID!, $configId: ID!) @inContext(country: ${window.Shopify.country}) {
  product(id: $id) {
    id
    title
    handle
    media(first: 2) {
      edges {
        node {
          alt
          mediaContentType
          ... on MediaImage {
            image {
              url
              altText
              height
              width
            }
          }
          ... on ExternalVideo {
            id
            originUrl
          }
          previewImage {
            id
            url
            altText
          }
        }
      }
    }
    onlineStoreUrl
    sideImage: metafield(namespace: "custom", key: "monogram_side_image") {
      reference {
        ... on MediaImage {
          alt
          previewImage {
            url
          }
        }
      }
    }
    topImage: metafield(namespace: "custom", key: "monogram_top_image") {
      reference {
        ... on MediaImage {
          alt
          previewImage {
            url
          }
        }
      }
    }
    monogramSettings: metafield(namespace: "custom", key: "monogram_settings") {
      reference {
        ... on Metaobject {
          id
          enablePositionSelection: field(key: "enable_position_selection") {
            value
          }
          mainPosition1: field(key: "main_position_1") {
            value
          }
          mainPosition2: field(key: "main_position_2") {
            value
          }
          sidePosition: field(key: "side_position") {
            value
          }
          numberOfInitials: field(key: "number_of_initials") {
            value
          }
          fontOptions: field(key: "font_options") {
            references(first: 20) {
              nodes {
                ${font}
              }
            }
          }
          sizeOptions: field(key: "size_options") {
            value
          }
          sizeOptions2: field(key: "size_options_2") {
            value
          }
          smallFontSize: field(key: "small_font_size") {
            value
          }
          mediumFontSize: field(key: "medium_font_size") {
            value
          }
          largeFontSize: field(key: "large_font_size") {
            value
          }
          disclaimer: field(key: "disclaimer") {
            value
          }
        }
      }
    }
  }
  globalConfig: metaobject(id: $configId) {
    id
    handle
    defaultFonts: field(key: "default_fonts") {
      references(first: 20) {
        nodes {
          ${font}
        }
      }
    }
    colors: field(key: "colors") {
      references(first: 50) {
        nodes {
          ... on Metaobject {
            label: field(key: "label") {
              value
            }
            color: field(key: "color") {
              value
            }
            image: field(key: "image") {
              reference {
                ... on MediaImage {
                  alt
                  previewImage {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
    shadowColors: field(key: "shadow_colors") {
      references(first: 50) {
        nodes {
          ... on Metaobject {
            label: field(key: "label") {
              value
            }
            color: field(key: "color") {
              value
            }
            image: field(key: "image") {
              reference {
                ... on MediaImage {
                  alt
                  previewImage {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  shop {
    monogramVariantGid: metafield(namespace: "custom", key: "monogram_variant_gid") {
      value
    }
  }
}
`;
